// 路由前置守卫：拦截所有页面请求
import auth from "@/util/auth";
import {router} from "@/router/router";
import {Loading, Message} from "element-ui";
import {error} from "vuescroll/src/shared/util";
import {validateToken} from "@/util/request";


const A_LOGIN_URL = "https://smartparking.njrentong.com/login?redirect=%2Findex"
router.beforeEach(async (to, from, next) => {

  const urlToken = auth.getTokenFromUrl();
  if(urlToken==='2'){
    next();
    return;
  }


  // 重试参数：最大10次，间隔2秒
  const maxRetries = 10;
  const retryInterval = 2000; // 2秒
  let retryCount = 0;
  const checkToken = () => {
    // 每次检查前先获取最新的token
    const token = auth.getToken();

    // 1. 创建全局加载提示（持续显示，带加载图标）
    const loadingInstance = Loading.service({
      lock: true, // 锁定屏幕，禁止点击
      text: '加载中...', // 提示文本
      spinner: 'el-icon-loading', // 加载图标（Element UI 内置）
      background: 'rgba(0, 0, 0, 0.7)' // 背景遮罩（可选，增强视觉效果）
    });



// 情况1：获取到token → 尝试验证
    if (token) {
      // Message.success(`第${retryCount + 1}次检查：已获取到token，开始验证`);
      try {
        // 验证token（注意：validateToken是异步的，需要await）
        if (token === '2') {
          loadingInstance.close();
          // 特殊token直接通过
          next();
        } else {
          // 调用接口验证token（需异步处理）
          validateToken().then(() => {
            loadingInstance.close();
            next(); // 验证通过，进入页面
          }).catch((error) => {
            // 验证失败 → 清除token并跳转
            console.log(`第${retryCount + 1}次验证失败（旧token无效），清除后重试`, error.message);
            auth.removeToken(); // 关键：清除无效的旧token，避免下次重复验证

            retryCount++;
            if (retryCount >= maxRetries) {
              // 达到最大次数仍失败 → 跳转登录
              loadingInstance.close();
             // Message.error('未获取到有效登录信息，请重新登录');
              setTimeout(() => window.location.href = A_LOGIN_URL, 3000);
            } else {
              // 继续重试，等待新token
              setTimeout(checkToken, retryInterval);
            }
          });
        }
      } catch (error) {
        // 验证过程出错 → 跳转登录
        auth.removeToken();
        loadingInstance.close();
        Message.error(error.message || '验证失败，请重新登录');
        setTimeout(() => {
          window.location.href = A_LOGIN_URL;
        }, 3000);
      }
      return; // 终止循环
    }

    // 情况2：未获取到token → 检查是否达到最大重试次数
    retryCount++;
    if (retryCount >= maxRetries) {
      // 达到最大次数 → 判定失败
      console.log(`已尝试${maxRetries}次，仍未获取到token`);
      Message.error('未获取到登录信息，请重新登录');
      loadingInstance.close();
      setTimeout(() => {
        window.location.href = A_LOGIN_URL;
      }, 3000);
      return; // 终止循环
    }

    // 情况3：未达最大次数 → 继续重试
    // Message.error(`第${retryCount}次检查：未获取到token，${retryInterval / 1000}秒后重试`);
    setTimeout(checkToken, retryInterval);
  };

// 启动第一次检查
  checkToken();


});
